import React, { Component } from "react";
import ReactGA from "react-ga";

import AppContext from "./AppContext";

import yamlUrl from "./quiz.yaml";
import yaml from "js-yaml";

import Quiz from "./Quiz";
import Check from "./Check";
import NoMatch from "./NoMatch";

import "bulma";
import "@fortawesome/fontawesome-free/css/all.css";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID || "UA-128572604-1");

class App extends Component {
  state = {
    QUIZ: null
  };

  constructor() {
    super();
  }

  async componentWillMount() {
    const response = await fetch(yamlUrl);
    const text = await response.text();
    const QUIZ = yaml.safeLoad(text);
    this.setState({ QUIZ });
  }

  render() {
    const { QUIZ } = this.state;

    if (!QUIZ) {
      return (
        <section className="section">
          <div className="container content">
            <div className="level level-item">
              <span className="icon is-large">
                <i
                  className={["fas fa-5x fa-spin fa-fw", "fa-sync"].join(" ")}
                />
              </span>
            </div>
          </div>
        </section>
      );
    }

    return (
      <AppContext.Provider value={this.state}>
        <Router basename={process.env.REACT_APP_BASENAME || "/"}>
          <Switch>
            <Route path="/" exact component={Quiz} />
            <Route path="/check" component={Check} />
            <Route component={NoMatch} />
          </Switch>
        </Router>
      </AppContext.Provider>
    );
  }
}

export default App;
